import { Grid, styled } from "@mui/material";
import { Facebook, Instagram, LinkedIn, YouTube } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import React from "react";
import { AiOutlineTikTok } from "react-icons/ai";
import { FaThreads } from "react-icons/fa6";
import { socialProfiles, type SocialPlatform } from "../../constants/social_links";
import { useBrandContact } from "../../lib/LiveContext";

const colours: Record<SocialPlatform, string> = {
  Facebook: "#4267B2",
  Instagram: "#222222",
  LinkedIn: "#0072b1",
  YouTube: "#FF0000",
  TikTok: "#000000",
  Threads: "#000000",
  X: "#1DA1F2",
};

const icons: Record<SocialPlatform, React.ReactNode> = {
  Facebook: <Facebook className="icon" />,
  Instagram: <Instagram className="icon" />,
  LinkedIn: <LinkedIn className="icon" />,
  YouTube: <YouTube className="icon" />,
  TikTok: <AiOutlineTikTok className="icon" />,
  Threads: <FaThreads className="icon" />,
  X: <XIcon className="icon" />,
};

/**
 * The row of square, brand-coloured profile icons. Shared by the press page's
 * social media section and the contact page's Follow Us.
 */
export const SocialIconLinks = () => {
  const profiles = socialProfiles(useBrandContact());

  return (
    <Grid container spacing={3} justifyContent="center">
      {profiles.map((profile) => (
        <Grid item key={"socialmedia-" + profile.name}>
          <a href={profile.url} target="_blank" rel="noreferrer" aria-label={profile.name}>
            <IconHolder style={{ backgroundColor: colours[profile.name] }}>
              {icons[profile.name]}
            </IconHolder>
          </a>
        </Grid>
      ))}
    </Grid>
  );
};

const SocialMedia = ({ strings }) => {
  return (
    <section className="fullWidthBG">
      <section className="fullWidthInner centerContent">
        <h1>{strings.social_media}</h1>
        <p>{strings.social_media_description}</p>
        <SocialIconLinks />
      </section>
    </section>
  );
};

const IconHolder = styled("div")(({ theme }) => ({
  borderRadius: "50%",
  width: "60px",
  height: "60px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.1)",
  },
  "& .icon": {
    color: "#FFFFFF",
    fontSize: "3rem",
    padding: theme.spacing(1),
    transition: ".2s ease-in-out",
  },
}));

export default SocialMedia;
